import * as fonts from '../constants/fonts';

import {
  CADMIUM_GREEN_LIGHT,
  CEZ_GREEN,
  CEZ_GREEN_DARK,
  COLORS_ACTION_HOVER,
  COLORS_ACTION_SELECTED,
  COLORS_BACKGROUND_DEFAULT,
  COLORS_ERROR,
  COLORS_PRIMARY_MAIN,
  COLORS_SECONDARY_MAIN,
  CRIMSON_GLORY,
  BLACK,
} from '../constants/colors';

export const materialUiTheme = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1440,
    },
  },
  mixins: {
    toolbar: {
      minHeight: '56px',
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: '56px',
      },
      '@media (min-width: 600px)': {
        minHeight: '56px',
      },
    },
  },
  palette: {
    primary: {
      main: COLORS_PRIMARY_MAIN,
    },
    secondary: {
      main: COLORS_SECONDARY_MAIN,
    },
    background: {
      default: COLORS_BACKGROUND_DEFAULT,
    },
    action: {
      hover: COLORS_ACTION_HOVER,
      hoverOpacity: 0.04,
      selected: COLORS_ACTION_SELECTED,
    },
    error: {
      main: COLORS_ERROR,
    },
  },
  typography: {
    fontFamily: `
    ${fonts.FONT_MAIN},
    ${fonts.FONT_SECONDARY},
    ${fonts.FONT_TERTIARY}`,
    h4: {
      fontFamily: `${fonts.FONT_SECONDARY}, ${fonts.FONT_TERTIARY}`,
      fontSize: fonts.FONTS_SIZE_H4,
      textTransform: 'uppercase',
      lineHeight: 1.343003,
      letterSpacing: '0.006715em',
    },
    h5: {
      fontFamily: `${fonts.FONT_SECONDARY}, ${fonts.FONT_TERTIARY}`,
      fontSize: fonts.FONTS_SIZE_H5,
      lineHeight: 1.33181,
      letterSpacing: 0,
    },
    subtitle1: {
      fontSize: fonts.FONTS_SIZE_SUBTITLE1,
      fontWeight: 500,
      lineHeight: 1.366,
      letterSpacing: '0.0085375em',
      color: BLACK,
    },
    body1: {
      fontSize: fonts.FONTS_SIZE_BODY1,
      letterSpacing: '0.0284576em',
      lineHeight: 1.19522,
      color: BLACK,
    },
    body2: {
      fontSize: fonts.FONTS_SIZE_BODY2,
      letterSpacing: '0.016254876em',
      lineHeight: 1.30039,
      color: BLACK,
    },
    caption: {
      fontSize: fonts.FONTS_SIZE_CAPTION,
      letterSpacing: '0.030349em',
      lineHeight: 1.21396,
      color: BLACK,
    },
    colorTextPrimary: {
      color: BLACK,
    },
  },
  overrides: {
    MuiTabs: {
      root: {
        borderBottom: '1px solid rgba(0,0,0,0.12)',
      },
    },
    MuiTab: {
      root: {
        fontSize: fonts.FONTS_SIZE_BODY2,
        letterSpacing: '0.0812744em',
        '@media (min-width: 600px)': {
          fontSize: fonts.FONTS_SIZE_BODY2,
          letterSpacing: '0.0812744em',
        },
        '&$selected': {
          color: COLORS_PRIMARY_MAIN,
        },
      },
    },
    MuiSvgIcon: {
      fontSizeLarge: {
        fontSize: '2rem',
      },
    },
    MuiIcon: {
      fontSizeLarge: {
        fontSize: '2rem',
      },
    },
    MuiSkeleton: {
      text: {
        height: '1.4375rem',
      },
    },
    MuiButton: {
      label: {
        marginTop: 2,
      },
    },
    MuiToolbar: {
      regular: {
        minHeight: '56px',
        '@media (min-width: 600px)': {
          minHeight: '56px',
        },
      },
    },
    MuiCheckbox: {
      root: {
        borderRadius: 0,
        color: CEZ_GREEN_DARK,
        '&$checked': {
          color: CEZ_GREEN,
        },
        '&$indeterminate': {
          color: CEZ_GREEN,
        },
      },
      checked: {},
      indeterminate: {},
    },
    MuiTableContainer: {
      root: {
        borderRadius: 0,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: '1px solid #E0E0E0',
        color: BLACK,
      },
      head: {
        color: BLACK,
        height: '56px',
      },
      body: {
        color: BLACK,
        height: '52px',
      },
      sizeSmall: {
        padding: '8px 16px',
      },
    },
    MuiTablePagination: {
      root: {
        color: BLACK,
      },
    },
    MuiList: {
      root: {
        '& > a.active': {
          backgroundColor: `${CADMIUM_GREEN_LIGHT} !important`,
          color: COLORS_PRIMARY_MAIN,
        },
      },
    },
    MuiListItem: {
      root: {
        '&:hover': {
          backgroundColor: `${CADMIUM_GREEN_LIGHT} !important`,
          color: COLORS_PRIMARY_MAIN,
        },
        color: BLACK,
      },
    },
    MuiMenuItem: {
      root: {
        paddingTop: 12,
        paddingBottom: 12,
      },
    },
    MuiBadge: {
      dot: {
        backgroundColor: CRIMSON_GLORY,
      },
      anchorOriginTopRightRectangle: {
        top: '5px',
        right: '5px',
      },
    },
    MuiToggleButton: {
      root: {
        color: BLACK,
        '&$selected': {
          color: BLACK,
          backgroundColor: CADMIUM_GREEN_LIGHT,
        },
      },
    },
  },
  custom: {
    dataTable: {
      header: {
        color: BLACK,
      },
      warningColor: CRIMSON_GLORY,
      placeholderLineHeight: '400px',
    },
  },
};
